import type { CSSProperties } from 'react';
import { styled } from 'styled-components';

import type { Theme } from '../../theme';

import type { HighlightedIconColor } from './types';

const textColorByColor = (theme: Theme): Record<HighlightedIconColor, CSSProperties['color']> => ({
  blue: theme.designTokens.highlightedIconBlueTextColor,
  green: theme.designTokens.highlightedIconGreenTextColor,
  orange: theme.designTokens.highlightedIconOrangeTextColor,
  purple: theme.designTokens.highlightedIconPurpleTextColor,
  red: theme.designTokens.highlightedIconRedTextColor,
  yellow: theme.designTokens.highlightedIconYellowTextColor,
  grey: theme.designTokens.highlightedIconGreyTextColor,
});

const backgroundColorByColor = (theme: Theme): Record<HighlightedIconColor, CSSProperties['background']> => ({
  blue: theme.designTokens.highlightedIconBlueBackgroundColor,
  green: theme.designTokens.highlightedIconGreenBackgroundColor,
  orange: theme.designTokens.highlightedIconOrangeBackgroundColor,
  purple: theme.designTokens.highlightedIconPurpleBackgroundColor,
  red: theme.designTokens.highlightedIconRedBackgroundColor,
  yellow: theme.designTokens.highlightedIconYellowBackgroundColor,
  grey: theme.designTokens.highlightedIconGreyBackgroundColor,
});

type ContainerProps = {
  color: HighlightedIconColor;
};

const Container = styled.span<ContainerProps>`
  display: inline-block;
  padding: ${({ theme }) => theme.designTokens.highlightedIconContainerPadding};
  border-radius: ${({ theme }) => theme.designTokens.highlightedIconRadius};
  color: ${({ theme, color }) => textColorByColor(theme)[color]};
  background: ${({ theme, color }) => backgroundColorByColor(theme)[color]};
`;

const IconWrapper = styled.span`
  padding: ${({ theme }) => theme.designTokens.highlightedIconPadding};
  display: inline-flex;
`;

export const Styled = {
  Container,
  IconWrapper,
};
